/**
 * Web Style Import
 *
 */

import './style/dnb-card.scss'
